















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

@Component({
  name: 'respondeco-file-input',
})
export default class RespondecoFileInput extends Vue {
  @Prop({
    default: '*',
    type: String,
  })
  public readonly accept!: string

  @Prop({
    default: 'common.form.choose_file',
    type: String,
  })
  public readonly label!: string
}
